import React from 'react'
import Logo from './Logo'
import Search from './Search'



const Header = () => {





  return (
    <div className='container flex'>
        <Logo />
        <Search/>
    </div>
  )
}

export default Header